import LegalPageEditor from './LegalPageEditor'

const SECTIONS = [
    { id: 'introduction', label: '1. Introduction' },
    { id: 'service', label: '2. The Service' },
    { id: 'account', label: '3. Account Registration & Security' },
    { id: 'billing', label: '4. Subscriptions, Billing & Payments' },
    { id: 'usage', label: '5. Acceptable Use' },
    { id: 'ip', label: '6. Intellectual Property' },
    { id: 'force-majeure', label: '7. Force Majeure' },
    { id: 'disclaimer', label: '8. Availability & Disclaimer' },
    { id: 'advice', label: '9. No Professional or Regulatory Advice' },
    { id: 'liability', label: '10. Limitation of Liability' },
    { id: 'data', label: '11. Data Protection' },
    { id: 'termination', label: '12. Termination' },
    { id: 'changes', label: '13. Changes to These Terms' },
    { id: 'governing', label: '14. Governing Law' },
]

export default function TermsCmsPage() {
    return (
        <LegalPageEditor
            page="terms"
            liveUrl={`${import.meta.env.VITE_FRONTEND_URL || 'https://tendercentrix.com'}/terms`}
            pageTitle="Terms & Conditions — Content Editor"
            pageDescription="Edit the hero and each of the 14 legal sections. Content is stored as HTML."
            sections={SECTIONS}
        />
    )
}
